import { render } from "./GuardarVentaModal.vue?vue&type=template&id=c061b180&scoped=true"
import script from "./GuardarVentaModal.vue?vue&type=script&lang=js"
export * from "./GuardarVentaModal.vue?vue&type=script&lang=js"

import "./GuardarVentaModal.vue?vue&type=style&index=0&id=c061b180&scoped=true&lang=css"
import "./GuardarVentaModal.vue?vue&type=style&index=1&id=c061b180&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c061b180"]])

export default __exports__